import { render, staticRenderFns } from "./CoProducers.vue?vue&type=template&id=26781403&"
import script from "./CoProducers.vue?vue&type=script&lang=js&"
export * from "./CoProducers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports